"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStarted = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const call_get_started_1 = require("../components/lobby/call_get_started");
const invitation_details_1 = require("../context/invitation_details");
const company_settings_1 = require("../context/company_settings");
const GetStarted = ({ invitationDetails, companySettings, handleGetStarted, hideStreemBranding, }) => {
    const InvitationDetailsProvider = (0, invitation_details_1.createInvitationDetailsProvider)(invitationDetails);
    const CompanySettingsProvider = (0, company_settings_1.createCompanySettingsProvider)(companySettings);
    return ((0, jsx_runtime_1.jsx)(CompanySettingsProvider, { children: (0, jsx_runtime_1.jsx)(InvitationDetailsProvider, { children: (0, jsx_runtime_1.jsx)(call_get_started_1.CallGetStarted, { onStart: handleGetStarted, hideStreemBranding: hideStreemBranding }) }) }));
};
exports.GetStarted = GetStarted;
//# sourceMappingURL=get_started.js.map